export default "__VITE_ASSET__BFPbkGaP__"